@if (dateRangeConfig) {
  <fieldset
    tabindex="0"
    class="form-control__wrapper--date-range"
    [attr.name]="config.prop"
    [attr.aria-label]="ariaLabel"
  >
    @for (date of dateProps; track date) {
      <zip-date-picker
        class="DateRange__DatePicker"
        (dateChanged)="updateValidators()"
        [config]="dateRangeConfig[date]"
        [control]="group.get(formGroupName).get(date)"
        [dateRangeProp]="config.prop"
      ></zip-date-picker>
    }
  </fieldset>
}
